// assets
import { UserOutlined, FileTextOutlined, BgColorsOutlined, BarcodeOutlined, ShoppingCartOutlined, InboxOutlined, RocketOutlined } from '@ant-design/icons';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import PaymentsIcon from '@mui/icons-material/Payments';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';

// icons
const icons = {
  UserOutlined,
  FileTextOutlined,
  BgColorsOutlined,
  BarcodeOutlined,
  ShoppingCartOutlined,
  InboxOutlined,
  RocketOutlined,
  FlightTakeoffIcon
  ,
  PaymentsIcon
  ,
  CurrencyExchangeIcon
  ,
  PointOfSaleIcon
};


// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'client-relations',
  title: 'Client Relations',
  type: 'group',
  children: [
    {
      id: 'clients',
      title: 'Clients',
      type: 'item',
      url: '/dashboard/clients',
      icon: icons.UserOutlined,
      target: false
    },
    {
      id: 'grn',
      title: 'Goods Received Note',
      type: 'item',
      url: '/dashboard/grns',
      icon: icons.InboxOutlined,
      target: false
    }
    ,
    {
      id: 'mrn',
      title: 'Material Requisitions',
      type: 'item',
      url: '/dashboard/mrns',
      icon: icons.BgColorsOutlined,
      target: false
    }
    ,
    {
      id: 'irf',
      title: 'Internal Requisition Forms',
      type: 'item',
      url: '/dashboard/irfs',
      icon: icons.BarcodeOutlined,
      target: false
    }
    ,
    {
      id: 'lpo',
      title: 'Local Purchase Orders',
      type: 'item',
      url: '/dashboard/lpos',
      icon: icons.ShoppingCartOutlined,
      roles: ['is_procurement', 'is_finance_manager', 'is_ceo','is_back_office'],
      target: false
    }
    ,
    {
      id: 'fpo',
      title: 'Foreign Purchase Orders',
      type: 'item',
      url: '/dashboard/fpos',
      icon: icons.FlightTakeoffIcon,
      roles: ['is_procurement', 'is_finance_manager', 'is_ceo','is_back_office'],
      target: false
    }
    ,
    {
      id: 'imprests',
      title: 'Imprests',
      type: 'item',
      url: '/dashboard/imprests',
      icon: icons.PaymentsIcon,
      target: false
    }
    ,
    {
      id: 'cash-requisition',
      title: 'Internal Cash Requisition',
      type: 'item',
      url: '/dashboard/cash-requisition',
      icon: icons.CurrencyExchangeIcon,
      target: false
    }
    ,
    {
      id: 'sales',
      title: 'Sales',
      type: 'item',
      url: '/dashboard/sales',
      icon: icons.PointOfSaleIcon,
      target: false
    }
  ]
};

export default pages;
